var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStitcher = function SvgStitcher(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460,1520L460,100L960,100L960,1520L460,1520Z",
    fill: "#622268",
    fillRule: "nonzero",
    transform: "matrix(0.006,0,0,0.006,0.7,2.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2230,1430L2230,270L2600,270L2600,1430L2230,1430Z",
    fill: "#c33727",
    fillRule: "nonzero",
    transform: "matrix(0.006,0,0,0.006,0.7,2.9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,1610L0,330L370,330L370,1610L0,1610Z",
    fill: "#3892c4",
    fillRule: "nonzero",
    transform: "matrix(0.006,0,0,0.006,0.7,2.9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1640,1520L1640,0L2140,0L2140,1520L1640,1520Z",
    fill: "#eb8a23",
    fillRule: "nonzero",
    transform: "matrix(0.006,0,0,0.006,0.7,2.9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1052,963L1055,225L1555,225L1557,963L1560,1700L1050,1700L1052,963Z",
    fill: "#fac617",
    fillRule: "nonzero",
    transform: "matrix(0.006,0,0,0.006,0.7,2.9)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStitcher, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stitcher.3ab5cfd5.svg";
export { ForwardRef as ReactComponent };